// src/pages/Login.js
// This file implements the login page for the invoice system.
// It collects username and password, calls the backend /api/login endpoint,
// stores the JWT token in localStorage, and redirects the user to /products on success.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import rLogo from '../../assets/logo.png';
import Rightbg from '../../assets/background-image.jpg';
import { Card, Form, Input, Button, Row, Col, message } from 'antd';
import { login } from '../../services/authService';
import { useAuth } from '../../auth/AuthContext';
import styles from './login.module.scss';

function Login() {
  const navigate = useNavigate();
  const auth = useAuth();

  const onFinish = async (values) => {
    try {
      const response = await login(values); // POST /api/login
      const { token } = response;

      if (token) {
        // setToken(token); // Save token to localStorage
        localStorage.setItem('token', token);
        auth.login(token);
        // Redirect user to the Home page
        navigate('/home', { replace: true });
      } else {
        message.error('Login failed, try again');
      }
    } catch (error) {
      const serverResponse = error?.response?.data?.error;
      if (serverResponse) {
        message.error(serverResponse.message);
      } else {
        message.error('Invalid credentials or server error');
      }
      console.error('Login error:', error);
    }
  };

  return (
    <div className={styles.container}>
      
        <Card
          className={styles.card}
        >
          <Row justify="center" align="middle" gutter="24">
            <Col xs={24} md={12} className={styles.leftSide}>
                <img src={rLogo} alt='retisioLogo' className={styles.logo}/>
                <h3>Welcome Back</h3>
                <p>Manage your Revenue & Billing System</p>
                <Form
                  onFinish={onFinish}
                  name="login"
                  layout="vertical"
                  autoComplete="off"
                  initialValues={{ email: '', password: '' }}
                >
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: 'Please enter your email' },
                      { type: 'email', message: 'Please enter a valid email' }
                    ]}
                  >
                    <Input placeholder="Enter email" />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      { required: true, message: 'Please enter your password' },
                      { min: 6, message: 'Password must be at least 6 characters' }
                    ]}
                  >
                    <Input.Password placeholder="Enter password" />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Sign In
                    </Button>
                  </Form.Item>
                </Form>
            </Col>
            <Col xs={0} sm={0} md={12}>
                <img src={Rightbg} alt='Manage Revenue and billing' className={styles.rightSideImg}/>
                <div><h6>Manage your Revenue & Billing System</h6><p>A unified experience hub for modern retailers to build and manage unique digital experiences and provide seamless shopping experience for consumers</p></div>
            </Col>
          </Row>
        </Card>
    </div>
  );
}

export default Login;
